var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "content" } },
    [
      _c("div", { staticClass: "header col-md-12" }, [
        _c("div", { staticClass: "header-inner row align-items-center" }, [
          _c("div", { staticClass: "col left" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("sidebar.expenses")) +
                  " > " +
                  _vm._s(_vm.$t("sidebar.create")) +
                  "\n        "
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content col-md-12" },
        [
          !_vm.ready
            ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
            : _vm._e(),
          _vm._v(" "),
          _vm.ready
            ? [
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: {
                          title: _vm.$t("message.vendor"),
                          subtitle: _vm.$t("series.ex") + " " + _vm.nextExCode
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "div",
                              { staticClass: "col" },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(_vm.$t("message.storecompanyperson"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("selectize", {
                                  attrs: {
                                    default: _vm.form.defaultVendorId,
                                    updateoption: _vm.form.updateOptionVendor,
                                    options: _vm.form.optionVendors,
                                    multiple: false,
                                    create: true,
                                    loading: _vm.form.loadingVendor,
                                    placeholder: _vm.$t(
                                      "placeholder.selectorcreate"
                                    )
                                  },
                                  on: { add: _vm.onAddedVendor },
                                  model: {
                                    value: _vm.form.pickedVendorId,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "pickedVendorId", $$v)
                                    },
                                    expression: "form.pickedVendorId"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.form.pickedVendorId
                        ? _c("div", { staticClass: "form-row" }, [
                            _c("div", { staticClass: "col-md-6" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "form-group row",
                                  staticStyle: { height: "100%" }
                                },
                                [
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c("label", [
                                      _vm._v(_vm._s(_vm.$t("message.address")))
                                    ]),
                                    _vm._v(" "),
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.form.vendor.address,
                                          expression: "form.vendor.address"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      staticStyle: {
                                        height: "calc(100% - 37px)"
                                      },
                                      domProps: {
                                        value: _vm.form.vendor.address
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.form.vendor,
                                            "address",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-6" }, [
                              _c("div", { staticClass: "form-group row" }, [
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("message.tel")))
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.vendor.tel,
                                        expression: "form.vendor.tel"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.form.vendor.tel },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.form.vendor,
                                          "tel",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group row" }, [
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("message.email")))
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.vendor.email,
                                        expression: "form.vendor.email"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.form.vendor.email },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.form.vendor,
                                          "email",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group row" }, [
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("message.taxpayerno")))
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.vendor.tax_id,
                                        expression: "form.vendor.tax_id"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: { type: "text" },
                                    domProps: { value: _vm.form.vendor.tax_id },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.form.vendor,
                                          "tax_id",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ])
                              ])
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.infopayment") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "div",
                              { staticClass: "col" },
                              [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("message.expclaimtype")))
                                ]),
                                _vm._v(" "),
                                _c("selectize", {
                                  attrs: {
                                    default: _vm.form.defaultDescription,
                                    options: _vm.form.optionDescriptions,
                                    validation:
                                      _vm.form.trickDescriptionValidation,
                                    multiple: false,
                                    create: true,
                                    placeholder: _vm.$t(
                                      "placeholder.selectorcreate"
                                    )
                                  },
                                  model: {
                                    value: _vm.form.pickedDescription,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "pickedDescription",
                                        $$v
                                      )
                                    },
                                    expression: "form.pickedDescription"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "div",
                              { staticClass: "col" },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "apps.expenses.message.expensetype"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("BaseDropdown", {
                                  attrs: { options: _vm.expenseOptions },
                                  model: {
                                    value: _vm.form.expense_type,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "expense_type", $$v)
                                    },
                                    expression: "form.expense_type"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "div",
                              { staticClass: "col" },
                              [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("message.date")))
                                ]),
                                _vm._v(" "),
                                _c("BaseInputDatePicker", {
                                  model: {
                                    value: _vm.form.created_at,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "created_at", $$v)
                                    },
                                    expression: "form.created_at"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.paidamount", {
                                      string: _vm.currency
                                    })
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.payment_amount,
                                    expression: "form.payment_amount"
                                  }
                                ],
                                staticClass: "form-control text-select-all",
                                attrs: { type: "text" },
                                domProps: { value: _vm.form.payment_amount },
                                on: {
                                  keypress: _vm.numberOnly,
                                  keyup: function($event) {
                                    _vm.form.payment_amount = _vm.setToValidNumber(
                                      _vm.form.payment_amount
                                    )
                                  },
                                  blur: function($event) {
                                    _vm.form.payment_amount = _vm.setToCustomDigitsNumber(
                                      _vm.form.payment_amount
                                    )
                                  },
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.form,
                                      "payment_amount",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "div",
                              { staticClass: "col" },
                              [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("message.taxes")))
                                ]),
                                _vm._v(" "),
                                _c("MultipleSelect", {
                                  attrs: {
                                    options: _vm.taxOptions,
                                    multiple: true
                                  },
                                  model: {
                                    value: _vm.form.taxIds,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "taxIds", $$v)
                                    },
                                    expression: "form.taxIds"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row mt-2" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "div",
                              { staticClass: "col" },
                              [
                                _c("b-form-textarea", {
                                  staticStyle: { "min-height": "126px" },
                                  attrs: {
                                    placeholder: _vm.$t("placeholder.note")
                                  },
                                  model: {
                                    value: _vm.form.note,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "note", $$v)
                                    },
                                    expression: "form.note"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "col-md-12 row no-padding no-margin"
                            },
                            [
                              _vm.taxResults.length > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 row no-margin no-padding"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-6 no-padding mb-2"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t("message.untaxed")
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6 no-padding mb-2 text-right"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.getNumber(_vm.total.untaxed)
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.taxResults, function(tax, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass:
                                      "col-12 row no-margin no-padding"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "col-6 no-padding mb-2" },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(tax.displayText) +
                                            "\n                  "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-6 no-padding mb-2 text-right"
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.getNumber(tax.total)) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _vm.taxResults.length > 0 &&
                              _vm.total.payment != _vm.total.grand &&
                              _vm.total.payment != _vm.total.untaxed
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 row no-margin mb-2 no-padding"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-6 no-padding" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t("message.totalamount")
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6 no-padding mb-2 text-right"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.getNumber(_vm.total.payment)
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-12 row no-margin no-padding"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-6 no-padding" },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.$t("message.netpayable")) +
                                          "\n                  "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-6 no-padding text-right"
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "text-underline-border"
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.getNumber(_vm.total.grand)
                                              ) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            2
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "section",
                  { staticClass: "action-bar" },
                  [
                    [
                      !_vm.$store.state.app.loading
                        ? _c("div", { staticClass: "col-md-12 text-right" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-web",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.save({ isCreateAnother: false })
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("button.save")))]
                            )
                          ])
                        : _c("div", { staticClass: "col-md-12 text-right" }, [
                            _vm._m(0)
                          ])
                    ]
                  ],
                  2
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("BaseConfirmDiscardModal", {
        attrs: { show: _vm.confirmDiscardModal.show },
        on: {
          onCancel: _vm.handleDiscardCancleModal,
          onConfirm: _vm.handleDiscardConfirmModal
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-web", attrs: { type: "button", disabled: "" } },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e07d6eea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e07d6eea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/expenses/ex/New.vue
// module id = null
// module chunks = 